import React, { Component } from 'react';
import { PageHeader, PageTitle, PdfViewer } from '../../components/index.js';
export class LoginAssistanceEnglish extends Component {
  render() {
    return (
      <div className="userpage">
        <div className="pdf-align-items pdf-page-bottom-align">
          <PageTitle title="Login Assistance Guide" />
          <PageHeader title="Login Assistance Guide">
            <div className="user-page">
              <i className="fas fa-sign-in-alt"></i>
            </div>
          </PageHeader>
          <div id="english"></div>
          <PdfViewer fileName="../loginAssistance/RSL_Testing_Application_Login_Assistance_Guide.pdf" containerId="english" />
        </div>
      </div>
    );
  }

}
export default LoginAssistanceEnglish;